"use client";
import React from "react";
import getHeightStyles from "../../styles/height/index.js";
import getRadiusStyles from "../../styles/radius/index.js";
import getWidthStyles from "../../styles/width/index.js";
import { classNames } from "../../utilities/helpers.js";
import s from "./Image.module.css";
const Image = (props) => {
    const { src, alt, width, height, onLoad, onError, fallback, displayMode = "cover", borderRadius, className, attributes, imageAttributes, } = props;
    const [status, setStatus] = React.useState("loading");
    const radiusStyles = getRadiusStyles(borderRadius);
    const widthStyles = getWidthStyles(width);
    const heightStyles = getHeightStyles(height);
    const baseClassNames = classNames(s.root, radiusStyles?.classNames, widthStyles?.classNames, heightStyles?.classNames, displayMode && s[`--display-mode-${displayMode}`], className);
    const imgClassNames = classNames(s.image, baseClassNames);
    const fallbackClassNames = classNames(s.fallback, baseClassNames);
    const style = {
        ...widthStyles?.variables,
        ...heightStyles?.variables,
    };
    const handleLoad = (e) => {
        setStatus("success");
        onLoad?.(e);
    };
    const handleError = (e) => {
        setStatus("error");
        onError?.(e);
    };
    React.useEffect(() => {
        setStatus("loading");
    }, [src]);
    if ((status === "error" || !src) && !!fallback) {
        if (typeof fallback === "string") {
            return (React.createElement("img", { ...attributes, src: fallback, alt: alt, role: alt ? undefined : "presentation", className: fallbackClassNames, style: style }));
        }
        return (React.createElement("div", { ...attributes, className: fallbackClassNames, style: style }, fallback));
    }
    return (React.createElement("img", { ...attributes, ...imageAttributes, src: src, alt: alt, role: alt ? undefined : "presentation", onLoad: handleLoad, onError: handleError, className: imgClassNames, style: style }));
};
export default Image;
